export const GET_ALL_INSTRUCTOR_BATCHES = "GET_ALL_INSTRUCTOR_BATCHES";

export const GET_BATCH_RELATED_STUDENTS = "GET_BATCH_RELATED_STUDENTS"; 